import { render, staticRenderFns } from "./AIMixer.vue?vue&type=template&id=be898bfc&scoped=true&"
import script from "./AIMixer.vue?vue&type=script&lang=js&"
export * from "./AIMixer.vue?vue&type=script&lang=js&"
import style0 from "../assets/style.css?vue&type=style&index=0&id=be898bfc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be898bfc",
  null
  
)

export default component.exports